export type TicketFlowStep =
  | "tickets"
  | "services"
  | "auth"
  | "guest-details"
  | "payment";

export type GuestInfo = {
  firstName: string;
  lastName: string;
  email: string;
  sex: string;
  ageGroup: string;
};

/** One expanded ticket instance with its own guest and per-ticket service selections */
export type TicketEntry = {
  ticketTypeId: string;
  ticketTypeName: string;
  ticketIndex: number; // 0-based within that ticket type
  guest: GuestInfo;
  serviceCounts: Record<string, number>; // serviceId → qty for THIS ticket
};

export type SelectedLineItem = {
  id: string;
  qty: number;
  item: Record<string, unknown>;
};

export type SellerInfo = {
  displayName: string;
  legalName: string;
  supportEmail: string;
  supportPhone?: string;
  vatId?: string;
  registeredAddress?: string;
  country?: string;
};

export type PurchasePayload = {
  tickets: SelectedLineItem[];
  ticketEntries: TicketEntry[];
  useSameGuest: boolean;
  acceptTerms: boolean;
  newsletterConsentSeller: boolean;
  newsletterConsentUpfest: boolean;
  totalPrice: number;
  step: TicketFlowStep;
  seller?: SellerInfo;
};

export const defaultGuestInfo = (): GuestInfo => ({
  firstName: "",
  lastName: "",
  email: "",
  sex: "",
  ageGroup: "",
});

export const sexOptions = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Other" },
];
